module.exports = __webpack_public_path__ + "static/people_pop32-659993701eca44e7abd661f9a32d12a6.png";